module.exports = __webpack_public_path__ + "static/responsible-investment-e8af8c2c22beb2e00e363cb0bc84d556.png";